<template>
  <div class="common">
        <nav class="footer">
            <div class="footerContent">
                <div class="footerHeader">
                    <img  @click="goHome" class="logo" src="../assets/headerLogo.svg"/>
                    <ul>
                        <li @click="goProducts">Products</li>
                        <li>Service Coverage Regions</li>
                        <li @click="goAboutUs">About us</li>
                        <li @click="goContactUs">Contact us</li>
                    </ul>
                </div>
                <div class="contactUs">
                    <div>PandaPay is a product of PandaPay Technology Limited, </br> a company licensed by the Custom and Excise department of Hong Kong.</div>
                    <div>Email: bd@hkpandapay.com</div>
                    <div>Business hours : 9:00 a.m to 6:00 p.m</div>
                    <div>
                        <span @click="goUserAgreement" style="color:#fff;cursor: pointer;">Service Terms</span>
                         and 
                        <span @click="goPrivacyPolicy" style="color:#fff;cursor: pointer;">Conditions</span>
                    </div>
                    <div>MSO License number: 20-01-02964</div>
                </div>
                <div class="footerImg">
                    <img @click="goHome" src="../assets/headerLogo.png"/>
                </div>
                <div class="standBy">
                    Copyright © {{year}}. Crafted with Pandapay.<br/>
                    <a href="https://www.linkedin.com/company/pandapay-mx"><img src="../assets/linkedin.png"/></a>
                </div>
            </div>
        </nav>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
        year:new Date().getFullYear()
    }
  },
  methods:{
      goContactUs(){
          this.$router.push('/contact')
          window.scrollTo(0, 0)
      },
      goHome(){
          this.model = false
          window.scrollTo(0, 0)
          this.$router.push('/')
      },
      goProducts(){
          this.model = false
          window.scrollTo(0, 700)
          this.$router.push('/')
      },
      goAboutUs(){
          this.model = false
          window.scrollTo(0, 3850)
          this.$router.push('/')
      },
      goUserAgreement(){
          this.$router.push('/userAgreement')
          window.scrollTo(0, 0)
      },
      goPrivacyPolicy(){
          this.$router.push('/privacyPolicy')
          window.scrollTo(0, 0)
      },
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width:960px){
    .common{
        position: relative;
        width: 100%;
        .footer{
            background: #0D2436;
            width: 100%;
            .footerContent{
                width: 80%;
                margin: 0 auto;
                .footerHeader{
                    position: relative;
                    display: flex;
                    .logo{
                        width: 210px;
                        height: 42px;
                        margin-top: 120px;
                        margin-right: 30px;
                    }
                    ul{
                        position: absolute;
                        right: 0;
                        margin-top: 120px;
                        list-style: none;
                        li{
                            cursor: pointer;
                            display: inline-block;
                            margin-left: 70px;
                            font-size: 18px;
                            font-family: OpenSans-Bold, OpenSans;
                            font-weight: bold;
                            color: #5A7184;
                        }
                        li:hover{
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .footerImg{
                display: none;
            }
            .contactUs{
                margin-top: 30px;
                font-size: 16px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color:#E1E1E1;
                line-height: 40px;
                span{
                    text-decoration: underline;
                }
            }
            .standBy{
                width: 360px;
                text-align: center;
                margin: 0 auto;
                font-size: 16px;
                font-family: OpenSans-SemiBold, OpenSans;
                font-weight: 600;
                color: #5A7184;
                margin-top: 120px;
                padding-bottom: 45px;
                line-height: 40px;
            }
        }
    }
}
@media all and (max-width:960px){
    .common{
        position: relative;
        width: 100%;
        .footer{
            background: #0D2436;
            width: 100%;
            .footerContent{
                margin: 0 18px;
                padding-top: 30px;
                .footerHeader{
                    position: relative;
                    .logo{
                        display: none;
                    }
                    ul{
                        list-style: none;
                        li{
                            cursor: pointer;
                            display: inline-block;
                            font-size: 18px;
                            font-family: OpenSans-Bold, OpenSans;
                            font-weight: bold;
                            color: #5A7184;
                            min-width: 140px;
                            margin-top: 25px;
                        }
                    }
                }
            }
            .contactUs{
                margin-top: 25px;
                font-size: 14px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #E1E1E1;
                line-height: 30px;
                span{
                    text-decoration: underline;
                }
            }
            .footerImg{
                text-align: center;
                margin-top: 75px;
                img{
                    width: 148px;
                    height: 30px;
                }
            }
            .standBy{
                text-align: center;
                margin: 0 auto;
                font-size: 10px;
                font-family: OpenSans-SemiBold, OpenSans;
                font-weight: 600;
                color: #5A7184;
                line-height: 25px;
                margin-top: 30px;
                padding-bottom: 180px;
                img{
                    width: 14px;
                }
            }
        }
    }
}
</style>
<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/footer.vue